import { FC } from "react";
import { TAlertAssetProps } from "./Alert.config";
import { Icon } from "../../primitives";
import { AlertAssetWrapper } from "./AlertAssetWrapper";
import { isAlertAssetIconKey } from "./Alert.guards";

export const AlertAsset: FC<TAlertAssetProps> = ({ asset }) => (
  <AlertAssetWrapper asset={asset}>
    { (asset && isAlertAssetIconKey(asset)) ? (
      <Icon
        className="shrink-0"
        icon={asset}
        size="sm"
      />
    ) : null }
  </AlertAssetWrapper>
);
